 
 <form nz-form *ngIf="mainformGroup && fieldNew && controlExists" [formGroup]="mainformGroup" [nzLayout]="'vertical'">
    <nz-form-item *ngIf="!field.hidden" [ngStyle]="field.noFormItemMarginBottom?{'margin-bottom':'0'}:{}">
        <nz-form-label  [nzFor]="fieldNew" *ngIf="!field.noLabel" [nzRequired]="field.required">{{field.label|translateTA}}</nz-form-label>
        <nz-form-control  [nzValidatingTip]="field.tooltip" nzHasFeedback>    
            <nz-date-picker  [style.width.%]="100" [formControlName]="fieldNew" [nzShowTime]="field.dateShowTime==null?true:field.dateShowTime" [nzFormat]="field.dateFormat==null?'yyyy-MM-dd HH:mm:ss':field.dateFormat" [nzPlaceHolder]="field.placeholder|translateTA" [nzSize]="field.size == null? 'default': field.size"  nzShowToday nzShowNow [nzDisabled]="field.isDisabled">
                @if (mainformGroup.get(field.field)?.value) {
                    <nz-icon nzInputPrefix class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" (click)="mainformGroup.get(field.field).setValue(null)" />
                }
            </nz-date-picker>
        </nz-form-control>
    </nz-form-item>
</form>


